'use client';

import { ChangeEvent, useEffect, useState, FC } from 'react';
import { AddClientTagFormProps } from './AddClientTagForm.types';
import { Button, ButtonGroup, Flex, Input } from '@/_components';

export const AddClientTagForm: FC<AddClientTagFormProps> = ({
  onConfirm,
  onCancel,
}) => {
  const [clientTag, setClientTag] = useState<string>('');

  const onCreate = () => {
    onConfirm(clientTag);
  };

  useEffect(() => {
    return () => setClientTag('');
  }, []);

  const onChangeClientTag = (event: ChangeEvent<HTMLInputElement>) =>
    setClientTag(event.target.value);

  return (
    <Flex isColumn={true} gap={8}>
      <Input
        label="New user tag"
        autoFocus={true}
        value={clientTag}
        onChange={onChangeClientTag}
      />
      <ButtonGroup align="right">
        <Button intent="secondary" onClick={onCancel} value="Cancel" />
        <Button
          intent="primary"
          onClick={onCreate}
          value="Create user tag"
          iconLeft="plus"
        />
      </ButtonGroup>
    </Flex>
  );
};
